// Replace {var} placeholders in a string with values from `vars`.
// Missing vars are left as the literal placeholder so misses are loud, not silent.
export function interpolate(
  template: string,
  vars: Readonly<Record<string, string | number>>,
): string {
  return template.replace(/\{(\w+)\}/g, (match, key: string) => {
    // `Object.hasOwn`, not a bare `vars[key]`: a bare read walks the prototype
    // chain, so `{constructor}` against `{}` rendered `function Object() {
    // [native code] }` into a user-facing string instead of staying a loud miss.
    // `createTranslator` already reads its catalog this way.
    const value = Object.hasOwn(vars, key) ? vars[key] : undefined;
    return value === undefined ? match : String(value);
  });
}
